import { render, staticRenderFns } from "./writeOff.vue?vue&type=template&id=abbdd56a&scoped=true&"
import script from "./writeOff.vue?vue&type=script&lang=js&"
export * from "./writeOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbdd56a",
  null
  
)

export default component.exports